module.exports = __webpack_public_path__ + "img/services-2.c835141b.jpg";